import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { USER_ROLES } from "../constants";

export const HomePage = () => {
  const { user } = useAuth();

  switch (user?.role) {
    case USER_ROLES.ADMIN:
      return <Navigate to="/concessionarias" replace={true} />;
    case USER_ROLES.STORE:
      return <Navigate to="/inicio" replace={true} />;
    default:
      return null;
  }
};
